import _home from "@/views/layouts/home/_home.vue";

export default [
    {
        path: "/",
        name: "_home",
        redirect: "/index",
        component:_home,
        children: [
            {
                path: "",
                name: "exchange",
                component: () => import(/* webpackChunkName: "home" */"../views/Home/Index.vue"),
                meta: {
                    title: "浦东新区游泳救生服务平台",
                    requiresAuth: true,
                    showloading: false,
                    share:true
                }
            },
            {
                path: "/index/:id?",
                name: "exchange",
                component: () => import(/* webpackChunkName: "home" */"../views/Home/Index.vue"),
                meta: {
                    title: "首页",
                    requiresAuth: true,
                    showloading: false,
                    share:true
                }
            },
            {
                path: "/infor",
                name: "information",
                component: () => import(/* webpackChunkName: "home" */"../views/Infor/index.vue"),
                meta: {
                    title: "咨讯",
                    requiresAuth: true,
                    showloading: false,
                    share:true
                }
            },
            // {
            //     path: "/recruit",
            //     name: "recruit",
            //     component: () => import(/* webpackChunkName: "home" */"../views/Recruit/index.vue"),
            //     meta: {
            //         title: "",
            //         requiresAuth: true,
            //         showloading: false,
            //         share:true
            //     }
            // },
            {
                path: "/news",
                name: "news",
                component: () => import(/* webpackChunkName: "home" */"../views/News/index.vue"),
                meta: {
                    title: "消息列表",
                    requiresAuth: true,
                    showloading: false,
                    share:true
                }
            },
            {
                path: "/my",
                name: "my",
                component: () => import(/* webpackChunkName: "my" */"../views/My/Index/index.vue"),
                meta: {
                    title: "我的",
                    showloading: false,
                    requiresAuth: true,
                    bgcolor:"#F5F5F5"
                }
            },
        ]
    },
    {
        path: "/my",
        name: "my",
        component: () => import(/* webpackChunkName: "my" */"../views/My/Index/index.vue"),
        meta: {
            title: "个人中心",
            showloading: false,
            requiresAuth: true,
            bgcolor:"#F5F5F5",
            children: [
                {
                    path: "uploadcert",
                    name: "UploadCert",
                    component: () => import(/* webpackChunkName: "my" */"../views/My/UploadCert/index.vue"),
                    meta: {
                        title: "证件上传",
                        showloading: false,
                        requiresAuth: true,
                        bgcolor:"#F5F5F5"
                    }
                }
            ]
        }
    },
    {
        path: "/recruit",
        name: "recruit",
        component: () => import(/* webpackChunkName: "home" */"../views/Recruit/index.vue"),
        meta: {
            title: "我要发布",
            requiresAuth: true,
            showloading: false,
            share:true
        }
    },
    {
        path: "/apply",
        name: "apply",
        component: () => import(/* webpackChunkName: "home" */"../views/Apply/index.vue"),
        meta: {
            title: "求职列表",
            requiresAuth: true,
            showloading: false,
            share:true
        }
    },
    {
        path: "/appdetail/:id",
        name: "appdetail",
        component: () => import(/* webpackChunkName: "home" */"../views/Apply/detail.vue"),
        meta: {
            title: "求职详情",
            requiresAuth: true,
            showloading: false,
            share:true
        }
    },
    {
        path: "/news/appdetail/:id",
        name: "news_ppdetail",
        component: () => import(/* webpackChunkName: "home" */"../views/News/appdetail.vue"),
        meta: {
            title: "求职详情",
            requiresAuth: true,
            showloading: false,
            share:true
        }
    },
    {
        path: "/my/uploadcert",
        name: "uploadcert",
        component: () => import(/* webpackChunkName: "home" */"../views/My/UploadCert/index.vue"),
        meta: {
            title: "证件上传",
            requiresAuth: true,
            showloading: false,
            share:true
        }
    },
    {
        path: "/my/resume",
        name: "resume",
        component: () => import(/* webpackChunkName: "home" */"../views/My/resume/index.vue"),
        meta: {
            title: "我的简历",
            requiresAuth: true,
            showloading: false,
            share:true
        }
    },
    {
        path: "/my/classlist",
        name: "classlist",
        component: () => import(/* webpackChunkName: "home" */"../views/My/class/list.vue"),
        meta: {
            title: "班级列表",
            requiresAuth: true,
            showloading: false,
            share:true
        }
    },
    {
        path: "/my/classdetail",
        name: "classdetail",
        component: () => import(/* webpackChunkName: "home" */"../views/My/class/detail.vue"),
        meta: {
            title: "学员列表",
            requiresAuth: true,
            showloading: true,
            share:true
        }
    },
    {
        path: "/my/userlist",
        name: "userlist",
        component: () => import(/* webpackChunkName: "home" */"../views/My/class/userlist.vue"),
        meta: {
            title: "学员列表",
            requiresAuth: true,
            showloading: true,
            share:true
        }
    },
    {
        path: "/jobs",
        name: "jobs",
        // redirect: "/jobs/list",
        // component:_home,
        component: () => import(/* webpackChunkName: "exchange" */"../views/Jobs/List/index.vue"),
        meta: {
            title: "招聘信息",
            showloading: false,
            requiresAuth: true,
            keepAlive: true,
            bgcolor:"#FFFFFF"
        }
    },
    {
        path: "/jobdetaill/:id",
        name: "jobdetaill",
        // redirect: "/jobs/list",
        // component:_home,
        component: () => import(/* webpackChunkName: "exchange" */"../views/Jobs/detail/index.vue"),
        meta: {
            title: "职位详情",
            showloading: false,
            requiresAuth: true,
            bgcolor:"#FFFFFF"
        }
    },
    {
        path: "/news/jobdetail/:id",
        name: "news_jobdetail",
        // redirect: "/jobs/list",
        // component:_home,
        component: () => import(/* webpackChunkName: "exchange" */"../views/News/jobdetail.vue"),
        meta: {
            title: "职位详情",
            showloading: false,
            requiresAuth: true,
            bgcolor:"#FFFFFF"
        }
    },
    {
        path: "/myinfo",
        name: "myinfo",
        component: () => import(/* webpackChunkName: "my" */"../views/My/Infor/index.vue"),
        meta: {
            title: "基本信息",
            showloading: false,
            requiresAuth: true,
            bgcolor:"#F5F5F5"
        }
    },
    {
        path: "/exchange/:goodsid?",
        name: "exchangedetail",
        component: () => import(/* webpackChunkName: "exchange" */"../views/Exchange/Detail/index.vue"),
        meta: {
            title: "详情",
            showloading: false,
            requiresAuth: true
        }
    },
    {
        path: "/orderconfirm/:orderid/:uaid?",
        name: "orderConfirm",
        component: () => import(/* webpackChunkName: "exchange" */"../views/Exchange/OrderConfirm/index.vue"),
        meta: {
            title: "订单确认",
            showloading: false,
            requiresAuth: true,
            bgcolor:"#F5F5F5"
        }
    },
    {
        path: "/address/:selectid?",
        name: "addressList",
        component: () => import(/* webpackChunkName: "exchange" */"../views/Address/Index/index.vue"),
        meta: {
            title: "地址",
            showloading: false,
            requiresAuth: true,

        }
    },
    {
        path: "/login",
        name: "login",
        component: () =>
            import(/* webpackChunkName: "login" */ "../views/Login/Login.vue"),
        meta: {
            title: "登录"
        }
    },
    {
        path: "/mppay",
        name: "mppay",
        component: () =>
            import(/* webpackChunkName: "login" */ "../views/Pay/Mppay.vue"),
        meta: {
            title: "微信支付",
            showloading: true
        }
    },
    {
        path: "/coin",
        name: "coinRecord",
        component: () =>
            import(/* webpackChunkName: "my" */ "../views/My/Coin/index.vue"),
        meta: {
            title: "健康值记录",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },
    {
        path: "/signlist",
        name: "signlist",
        component: () =>
            import(/* webpackChunkName: "my" */ "../views/My/Sign/index.vue"),
        meta: {
            title: "我的报名",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },

    {
        path: "/applydetail/:id",
        name: "applydetail",
        component: () =>
            import(/* webpackChunkName: "my" */ "../views/My/Sign/applydetail.vue"),
        meta: {
            title: "报名信息",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },
    {
        path: "/refundorder/:orderid",
        name: "refundorder",
        component: () =>
            import("../views/Order/Refund/index.vue"),
        meta: {
            title: "申请退款",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },
    {
        path: "/refunddetail/:ordersn",
        name: "refunddetail",
        component: () =>
            import("../views/Order/Refund/detail.vue"),
        meta: {
            title: "申请退款详情",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },
    {
        path: "/orders",
        name: "myOrders",
        component: () =>
            import(/* webpackChunkName: "order" */ "../views/Order/Index/index.vue"),
        meta: {
            title: "兑换记录",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },
    {
        path: "/order/:orderid",
        name: "orderDetail",
        component: () =>
            import(/* webpackChunkName: "order" */ "../views/Order/Detail/index.vue"),
        meta: {
            title: "订单详情",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },
    {
        path: "/feedback",
        name: "feedback",
        component: () =>
            import(/* webpackChunkName: "my" */ "../views/My/Feedback/index.vue"),
        meta: {
            title: "意见反馈",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },
    {
        path: "/edit",
        name: "userEdit",
        component: () =>
            import(/* webpackChunkName: "my" */ "../views/My/Edit/index.vue"),
        meta: {
            title: "信息修改",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },
    {
        path: "/signup",
        name: "signup",
        component: () =>
            import(/* webpackChunkName: "my" */ "../views/Sign/index.vue"),
        meta: {
            title: "培训详情",
            requiresAuth: true,
            bgcolor:"#ffffff"

        }
    },
    {
        path: "/certificate",
        name: "certificate",
        component: () =>
            import(/* webpackChunkName: "my" */ "../views/My/certificate/index.vue"),
        meta: {
            title: "个人证书",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },
    {
        path: "/signuplist",
        name: "signuplist",
        component: () =>
            import(/* webpackChunkName: "my" */ "../views/My/signuplist/index.vue"),
        meta: {
            title: "报名列表",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },
    
    {
        path: "/getZdetail/:id",
        name: "getZdetail",
        component: () =>
            import(/* webpackChunkName: "my" */ "../views/Infor/detail.vue"),
        meta: {
            title: "资讯详情",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },
    {
        path: "/signdetail",
        name: "signdetail",
        component: () =>
            import(/* webpackChunkName: "my" */ "../views/My/signuplist/detail.vue"),
        meta: {
            title: "发布通知",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    },
    {
        path: "/noticeview/:id",
        name: "noticeview",
        component: () =>
            import(/* webpackChunkName: "my" */ "../views/My/signuplist/view.vue"),
        meta: {
            title: "通知详情",
            requiresAuth: true,
            bgcolor:"#F5F5F5"

        }
    }
];
